import React from "react";
import MainVannerCSS from "./MainVanner_dev.module.css";

function MainVanner() {

  return (
    <div className={MainVannerCSS.baseStart}>
      <img className={MainVannerCSS.back} src="img/en/main_10_2.png" alt="main" />
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link1}>
            <a href="https://youtu.be/MtQDeUUollQ?si=V5q0ngA7iht3mKiT" target="_blank" >
            <img src="img/blank_300_150.png" alt="arrow"/></a>
          </div>
        </div>
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link2}>
            <a href="https://youtu.be/voCRZf2fkJY?si=O9xBgC2vbZqnsY2F" target="_blank" >
            <img src="img/blank_300_150.png" alt="arrow"/></a>
          </div>
        </div>              
        <div className={MainVannerCSS.btnBase}>
          <div className={MainVannerCSS.btn}></div>
          <div className={MainVannerCSS.link3}>
            <a href="https://youtu.be/1yQ6cz4530U?si=GtLEejUJPvXrRdsI" target="_blank" >
            <img src="img/blank_300_150.png" alt="arrow"/></a>
          </div>
          </div>    
          <div className={MainVannerCSS.btnBase}>
              <div className={MainVannerCSS.btn}></div>
              <div className={MainVannerCSS.link4}>
                  <a href="/Product_en" >
                      <img src="img/blank_300_150.png" alt="arrow" /></a>
              </div>
          </div>            
          <img className={MainVannerCSS.back} src="img/en/main_10_3.png" alt="main" />  
    </div>
  );
}
export default MainVanner;
